import {z as zod} from "zod";

export type OttopilotBobcardWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotBobcardWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotBobcardWorkspaceCapabilityConfiguration> = zod.strictObject({});
